/* ============================================================
   Tracking Page — client-side logic
   ============================================================ */

(function () {
  'use strict';

  // ---- Config (injected by Liquid) ----
  const API_URL = window.__TRACKING_API_URL__;

  // ---- DOM refs ----
  const form   = document.getElementById('tp-form');
  const input  = document.getElementById('tp-input');
  const card   = document.getElementById('tp-result-card');

  const elCarrier    = document.getElementById('tp-carrier');
  const elNumber     = document.getElementById('tp-number');
  const elBadge      = document.getElementById('tp-badge');
  const elBadgeDot   = document.getElementById('tp-badge-dot');
  const elFill       = document.getElementById('tp-fill');
  const elLastUpdate = document.getElementById('tp-last-update');
  const elTimestamp  = document.getElementById('tp-timestamp');
  const elEvents     = document.getElementById('tp-events-list');
  const elState      = document.getElementById('tp-state');

  // Step elements (0-4)
  const steps = Array.from({ length: 5 }, (_, i) => document.getElementById(`tp-step-${i}`));

  // ---- SVG icons ----
  const ICON_PIN = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`;
  const ICON_CLOCK = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>`;

  // ---- Helpers ----

  // Text that comes back from the tracking API (17TRACK, relayed by our proxy)
  // is data, never markup. Escaping it means a compromised or malformed
  // upstream response cannot inject script into the store page.
  function esc(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  function formatDate(raw) {
    if (!raw) return '';
    try {
      const d = new Date(raw);
      if (isNaN(d)) return raw;
      return d.toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
      });
    } catch { return raw; }
  }

  function setStepState(stepIndex, status) {
    // status: 'done' | 'active' | 'pending'
    const el = steps[stepIndex];
    if (!el) return;
    el.classList.remove('is-done', 'is-active');
    if (status === 'done')   el.classList.add('is-done');
    if (status === 'active') el.classList.add('is-active');
  }

  function applyProgress(step) {
    // step 0-4
    const percent = step === 0 ? 0 : (step / 4) * 100;
    elFill.style.width = percent + '%';

    for (let i = 0; i < 5; i++) {
      if (i < step)      setStepState(i, 'done');
      else if (i === step) setStepState(i, 'active');
      else                 setStepState(i, 'pending');
    }
  }

  function showState(type, message) {
    // type: 'loading' | 'error' | 'not-found'
    card.classList.add('is-visible');

    const icons = {
      loading: `<div class="tp-spinner"></div>`,
      error: `<div class="tp-state__icon"><svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg></div>`,
      'not-found': `<div class="tp-state__icon"><svg viewBox="0 0 24 24"><path d="M20 6h-2.18c.07-.44.18-.88.18-1.35C18 2.53 15.47 0 12.33 0c-1.7 0-3.21.8-4.22 2.05L12 6H20zM1.69 0L.31 1.38 4 5.07V6H2C.9 6 0 6.9 0 8v12c0 1.1.9 2 2 2h16c.55 0 1.05-.22 1.41-.59l1.28 1.28 1.38-1.38L1.69 0z"/></svg></div>`,
    };

    elState.innerHTML = `
      <div class="tp-state">
        ${icons[type] || icons.error}
        <p class="tp-state__title">${esc(message)}</p>
      </div>`;

    elState.style.display = 'block';

    // Hide other sections
    document.getElementById('tp-result-header').style.display = 'none';
    document.getElementById('tp-progress-section').style.display = 'none';
    document.getElementById('tp-last-update-bar').style.display = 'none';
    document.getElementById('tp-events-section').style.display = 'none';
  }

  function renderResult(data) {
    // Show structural sections
    document.getElementById('tp-result-header').style.display = '';
    document.getElementById('tp-progress-section').style.display = '';
    document.getElementById('tp-last-update-bar').style.display = '';
    document.getElementById('tp-events-section').style.display = '';
    elState.style.display = 'none';
    card.classList.add('is-visible');

    // Header
    elNumber.textContent = data.number;
    elCarrier.textContent = data.carrier;
    elBadge.textContent = data.status;
    elBadge.style.background = data.statusColor || '#6366F1';
    elBadge.prepend(elBadgeDot);

    // Progress
    applyProgress(data.statusStep || 0);

    // Last update
    elTimestamp.textContent = data.lastUpdate ? formatDate(data.lastUpdate) : 'N/A';

    // Events
    if (!data.events || data.events.length === 0) {
      elEvents.innerHTML = '<div class="tp-no-events">No tracking events yet. Check back soon.</div>';
      return;
    }

    elEvents.innerHTML = data.events.map((ev, idx) => `
      <div class="tp-event">
        <div class="tp-event__dot"></div>
        <div class="tp-event__desc">${esc(ev.description || 'Update')}</div>
        <div class="tp-event__meta">
          ${ev.date ? `<span>${ICON_CLOCK}${esc(formatDate(ev.date))}</span>` : ''}
          ${ev.location ? `<span>${ICON_PIN}${esc(ev.location)}</span>` : ''}
        </div>
      </div>
    `).join('');
  }

  // ---- Main fetch ----

  async function track(number) {
    showState('loading', 'Fetching tracking information…');

    try {
      const url = `${API_URL}?number=${encodeURIComponent(number)}`;
      const res  = await fetch(url, { cache: 'no-store' });
      const data = await res.json();

      if (!res.ok) {
        const msg = data.error || 'Could not retrieve tracking information.';
        showState('error', msg);
        return;
      }

      renderResult(data);

    } catch (err) {
      console.error('[tracking]', err);
      showState('error', 'Connection error. Please try again.');
    }
  }

  // ---- Event listeners ----

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const num = input.value.trim();
      if (!num) {
        input.focus();
        return;
      }
      // Update URL param for shareable links
      const url = new URL(window.location.href);
      url.searchParams.set('tracking', num);
      window.history.replaceState({}, '', url);
      track(num);
    });
  }

  // ---- Left column: order number + email ----
  //
  // This column used to be decorative: nothing listened to it, so pressing
  // TRACK just reloaded the page. It now calls /api/order, which resolves the
  // order into a tracking number server-side (the storefront cannot read orders
  // on its own) and then feeds that number into the same track() above.
  //
  // If ORDER_API_URL is not configured, the column is hidden instead of left
  // sitting there pretending to work.
  const ORDER_API_URL = window.__ORDER_API_URL__;

  const orderForm    = document.getElementById('tp-order-form');
  const orderInput   = document.getElementById('tp-order-input');
  const contactInput = document.getElementById('tp-email-input');

  async function trackByOrder(orderNumber, contact) {
    showState('loading', 'Looking up your order…');
    try {
      const url = `${ORDER_API_URL}?order=${encodeURIComponent(orderNumber)}` +
                  `&contact=${encodeURIComponent(contact)}`;
      const res  = await fetch(url, { cache: 'no-store' });
      const data = await res.json();

      if (!res.ok) {
        showState('not-found', data.error || 'We could not find that order.');
        return;
      }
      // Found, but nothing to track yet (not shipped, or carrier still silent).
      if (!data.number) {
        showState('not-found', data.message || 'No tracking available yet.');
        return;
      }
      if (input) input.value = data.number;
      track(data.number);
    } catch (err) {
      console.error('[tracking:order]', err);
      showState('error', 'Connection error. Please try again.');
    }
  }

  if (orderForm) {
    // Bound even when the lookup is unavailable: a submit must never reload
    // the page and wipe what the customer typed.
    orderForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!ORDER_API_URL) return;
      const num     = (orderInput.value || '').trim();
      const contact = (contactInput.value || '').trim();
      if (!num)     { orderInput.focus();   return; }
      if (!contact) { contactInput.focus(); return; }
      trackByOrder(num, contact);
    });

    if (!ORDER_API_URL) {
      const col     = orderForm.closest('.tp-col');
      const divider = document.querySelector('.tp-divider');
      const columns = document.querySelector('.tp-search-columns');
      if (col)     col.style.display = 'none';
      if (divider) divider.style.display = 'none';
      if (columns) columns.classList.add('is-single');
    }
  }

  // Auto-track if query param present
  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const pre    = params.get('tracking') || params.get('number');
    if (pre) {
      input.value = pre;
      track(pre);
    }
  });

})();
